export default __webpack_public_path__ + "static/media/Amper-2017.fe0b6579.svg";